import { render, staticRenderFns } from "./NationwideUniversalTicket.vue?vue&type=template&id=497fc268&scoped=true&"
import script from "./NationwideUniversalTicket.vue?vue&type=script&lang=js&"
export * from "./NationwideUniversalTicket.vue?vue&type=script&lang=js&"
import style0 from "./NationwideUniversalTicket.vue?vue&type=style&index=0&id=497fc268&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497fc268",
  null
  
)

export default component.exports